import styled from 'styled-components';

export const ProfileImg = styled.div<{ size: number; plain?: boolean }>`
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  min-height: ${(props) => props.size}px;
  min-width: ${(props) => props.size}px;
  ${({ plain = false }) =>
    plain
      ? null
      : `
  margin-right: 10px;
  `}
  border-radius: 50%;
  position: relative;
  box-shadow: ${({ theme }) => theme.shadows[1]};
  vertical-align: 0;
`;

export const ViewingIcon = styled.div`
  width: 21px;
  height: 21px;
  position: absolute;
  bottom: -6px;
  left: -6px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.background.paper};
  font-size: 17px;
  text-align: center;
`;

export const NotificationIcon = styled.div`
  width: 15px;
  height: 15px;
  position: absolute;
  top: -3px;
  right: -6px;
  background: ${({ theme }) => theme.palette.primary.main};
  border-radius: 50%;
  overflow: hidden;

  &:after {
    content: '!';
    background-color: ${({ theme }) => theme.palette.primary.main};
    display: flex;
    color: ${({ theme }) => theme.palette.primary.contrastText};
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }
`;
